export default "../css/5a990a7c9a4f685cbb8f66e0b6b6f236.ttf";